import React, { useEffect, useRef } from 'react';
import * as ArrayExtensions from '../../../../utils/CoreExtensions/ArrayExtensions';
import { closeActionRenderer } from './utils';
import ChrLink from '../ChrLink';
import { mergeProps } from '../mergeProps';
import i18n from '../../../../utils/ChrI18n';

const ChrMountedModal = props => {
  const modalRef = useRef();
  const { extraModalBodyProps = {}, extraModalContentProps = {}, extraModalOptions = {}, extraModalProps = {}, extraModalDialogProps = {} } = props;
  useEffect(() => {
    jQuery(modalRef.current).modal({ show: false, ...extraModalOptions });
    jQuery(modalRef.current).on('hidden.bs.modal', function (_event) {
      props.hideModal();
    });
  }, []);
  useEffect(() => {
    let toggleOperation = props.show ? 'show' : 'hide';
    jQuery(modalRef.current).modal(toggleOperation);
  }, [props.show]);
  const closeAction = closeActionRenderer(props);
  const modalSizeClass = props.size ? `modal-${props.size}` : '';

  let footerContent = [];
  if (props.includeCloseAction) footerContent.push(closeAction);
  if (props.footer) footerContent.push(props.footer);
  const modalBodyProps = mergeProps(
    { className: "modal-body" },
    extraModalBodyProps
  );
  const modalContentProps = mergeProps(
    { className: "modal-content" },
    extraModalContentProps
  );
  const modalProps = mergeProps(
    { className: "modal fade" },
    extraModalProps
  )
  const modalDialogProps = mergeProps(
    { className: `modal-dialog ${modalSizeClass}` },
    extraModalDialogProps
  )

  const oncloseModal = () => {
    props.closeButtonOnClickHandler?.();
    props.hideModal();
  }

  return (
    <div ref={ modalRef } {...modalProps} tabIndex={ -1 } aria-modal aria-hidden aria-label={ props.header || i18n.t("display_string.Details") }>
      <div {...modalDialogProps} role="document">
        <div { ...modalContentProps }>
          { !props.hideHeader &&
            <div className={ `modal-header d-block ${props.headerClassName}` }>
              <div className="d-flex">
                <div className="modal-title">{ props.header }</div>
                <div className="ml-auto">
                  <ChrLink onClick={oncloseModal} noHref className="text-muted">
                    <i className="fa-regular fa-times fa-fw m-r-xs" />
                  </ChrLink>
                </div>
              </div>
            </div>
          }
          <div { ...modalBodyProps }>
            { props.body || props.children }
          </div>
          { ArrayExtensions.isPresent(footerContent) &&
            <div className={ `modal-footer ${props.footerClassName}` }>
              { footerContent }
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default ChrMountedModal;
